module.exports = __webpack_public_path__ + "img/SDG-10.92ec10cb.svg";